/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Description_TitleInputs */



/**
* | output |
* | --- |
* | "Record Description" |
*
* @param {Explorer_Info_Description_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_description_title = /** @type {((inputs?: Explorer_Info_Description_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Description_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Record Description")
	if (locale === "de") return /** @type {LocalizedString} */ ("Record Description")
	if (locale === "it") return /** @type {LocalizedString} */ ("Record Description")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Record Description")
	if (locale === "es") return /** @type {LocalizedString} */ ("Record Description")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Record Description")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Record Description")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Record Description")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Record Description")
	return /** @type {LocalizedString} */ ("Record Description")
});